import { MetaTags } from 'components/MetaTags';
import FaqPage from 'components/FAQPage';

const Faqs = () => (
  <>
    <MetaTags title="FAQ" />
    <FaqPage />;
  </>
);

export default Faqs;
